import { LanguageSelector } from '@efexteam/components';
import { useTranslation } from 'react-i18next';
import { es, usFlag } from '@/assets';

const LanguageComponent = () => {
  const { t, i18n } = useTranslation();
  const { language, changeLanguage } = i18n;

  const languagesOptions = [
    {
      code: 'es',
      name: t('spanish'),
      flag: es,
      alt: 'Spanish',
    },
    {
      code: 'en',
      name: t('english'),
      flag: usFlag,
      alt: 'English',
    },
  ];

  return (
    <LanguageSelector
      dense
      currentLanguage={language}
      onLanguageChange={changeLanguage}
      languages={languagesOptions}
    />
  );
};

export default LanguageComponent;
